// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"iz_a bhr_vu bhr_ql bhr_va bhr_gy bhr_kg bhr_sv","ProfileAdminTools__item":"iz_b"};